import { TASK_KIND, type TaskKind } from "@/lib/tasks/task-types"
import { cx } from "@/lib/utils/cx"

// The kind chip — the same object in the list row and the card, so a task
// looks like itself wherever it appears. Monochrome: the glyph and the word
// do the telling; colour on this screen is reserved for state.

export function TaskChip({
  kind,
  size = "sm",
  className,
}: {
  kind: TaskKind
  size?: "sm" | "md"
  className?: string
}) {
  const spec = TASK_KIND[kind]
  const Glyph = spec.glyph
  return (
    <span
      className={cx(
        "inline-flex items-center gap-1 rounded-md ring-1 ring-inset font-bold uppercase tracking-[0.1em] shrink-0",
        size === "sm" ? "h-[22px] px-1.5 text-[10.5px]" : "h-6 px-2 text-[11px]",
        spec.tokens.chip,
        className,
      )}
    >
      <Glyph className={cx("shrink-0", size === "sm" ? "size-3" : "size-3.5", spec.tokens.glyph)} aria-hidden />
      {spec.label}
    </span>
  )
}
